import script from "./ByUrlParam.vue?vue&type=script&setup=true&lang=js"
export * from "./ByUrlParam.vue?vue&type=script&setup=true&lang=js"

import "./ByUrlParam.vue?vue&type=style&index=0&id=6407c710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6407c710"]])

export default __exports__